// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"featured-blog-component_uk-open__bf22F","grecaptcha-badge":"featured-blog-component_grecaptcha-badge__7fO82","featured-blog":"featured-blog-component_featured-blog__81hO1","title":"featured-blog-component_title__li4sA","body":"featured-blog-component_body__yluxd"};
    if(module.hot) {
      // 1793877036921
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  